import { CloseIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import CircleXIcon from '../../../../../Cutesies/CircleXIcon';
import ImportParticipantsStore from '../../../Store';
import { ImportedParticipants } from '../../../Store/Types';
import ImportMessage from '../Shared/ImportMessage';
import StatusMessage from '../Shared/StatusMessage';
import ViewAndDownloadCSV from '../Shared/ViewAndDownloadCSV';

interface Props {
  totalCount: number;
  store: ImportParticipantsStore;
  importedParticipants: ImportedParticipants;
}

function FailedImport({ totalCount, store, importedParticipants }: Props) {
  const failedParticipants = [
    ...importedParticipants.failedParticipants,
    ...importedParticipants.formattingIssue,
    ...importedParticipants.participantsOfDifferentOrg,
    ...importedParticipants.participantsOfSameOrg,
  ];

  return (
    <div className="flex flex-col items-center">
      <StatusMessage
        icon={<CircleXIcon width="160" height="160" />}
        messageKey="Import Not Successful"
      />
      <p className="font-semibold text-sm">
        <T kind="{{count}} participants could not be imported" count={totalCount} />
      </p>
      <ViewAndDownloadCSV store={store} downloadData={failedParticipants} view="full-view" />
      <hr className="border-t border-[#D9D9D9] w-4/5 my-4 h-1" />
      <ImportMessage
        store={store}
        importedParticipants={importedParticipants}
        icon={<CloseIcon size="md" color="red" />}
      />
      <hr className="border-t border-[#D9D9D9] w-4/5 my-4 h-1" />
    </div>
  );
}

export default observer(FailedImport);
